import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) =>
	({
		root: {
			backgroundColor: theme.palette.primary.main,
		},
		actionsIcon: {
			marginLeft: 5,
		},
	} satisfies Record<string, CSSObject>);